var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1533_224",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 80
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1533_224)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.8886 56.6136L76.9637 55.5848C76.9863 55.1758 53.6677 31.8188 53.6677 31.8188H53.113C53.113 31.8188 76.7486 58.1385 76.8914 56.6136H76.8886Z",
    fill: "url(#paint0_linear_1533_224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1374 48.5104L27.044 48.7254L26.9428 48.9494C26.1996 50.5857 37.3491 62.0926 38.2458 60.6948L38.3684 60.5061L38.5035 60.2924C39.2206 59.143 27.4555 47.7662 27.1371 48.5135L27.1374 48.5104Z",
    fill: "url(#paint1_linear_1533_224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8927 64.6919C42.8637 64.7652 42.6367 65.1657 42.4317 65.3773C42.397 65.4505 53.3161 76.8826 53.3161 76.8826H54.2992C54.2998 76.8826 44.0493 65.1752 42.8927 64.6919Z",
    fill: "url(#paint2_linear_1533_224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9797 55.3762C76.469 67.3269 67.104 76.8825 55.6621 76.8825H54.1151L42.6888 64.9986C43.6286 63.5992 44.5025 62.1494 45.2804 60.6376H55.6621C58.9454 60.6376 61.6173 57.8184 61.6173 54.3504C61.6173 50.884 58.9454 48.0632 55.6621 48.0632H49.5187C49.9872 45.4509 50.2428 42.7574 50.2428 40.0014C50.2428 37.2035 49.9825 34.4715 49.4973 31.8174H53.3135L76.9097 56.3662C76.9378 56.0366 76.9602 55.7066 76.9771 55.3762H76.9797ZM9.2076 3H3V19.2448H9.2076C20.0494 19.2448 28.8711 28.5558 28.8711 40.0014C28.8728 43.0152 28.2492 45.9929 27.0442 48.725L38.3689 60.5088C42.2171 54.4429 44.2682 47.3051 44.261 40.0044C44.261 19.5989 28.5357 3 9.2076 3Z",
    fill: "url(#paint3_linear_1533_224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6617 3H30.5248C36.6647 6.95734 41.7483 12.5687 45.2126 19.2448H55.662C58.9452 19.2448 61.6172 22.0641 61.6172 25.5321C61.6172 29 58.9452 31.8184 55.6617 31.8184H53.3137L76.9099 56.3668C76.9654 55.7013 77.0001 55.0309 77.0001 54.3504C77.0001 48.8737 75.1387 43.8504 72.0481 39.9403C75.1387 36.0322 77.0001 31.0079 77.0001 25.5321C77.003 13.1084 67.4303 3 55.6617 3Z",
    fill: "url(#paint4_linear_1533_224)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1151 76.8829H30.7048C35.4171 73.8106 39.4909 69.7546 42.6888 64.999L54.1151 76.8829ZM38.3689 60.5062L27.045 48.7224C23.9162 55.8202 17.099 60.7571 9.2076 60.7571H3V77.0001H9.2076C21.3527 77.0001 32.0809 70.4403 38.3689 60.5028V60.5062Z",
    fill: "url(#paint5_linear_1533_224)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1533_224",
    x1: 2560.4,
    y1: 499.558,
    x2: 6387.67,
    y2: 4366.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A03C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1533_224",
    x1: -222.368,
    y1: 644.788,
    x2: 1540.79,
    y2: 2274.07,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A03C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1533_224",
    x1: 573.815,
    y1: 1252.93,
    x2: 2164.84,
    y2: 2980.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A03C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1533_224",
    x1: 2149.08,
    y1: -322.821,
    x2: 15595.1,
    y2: 16489.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26D58"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9A03C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1533_224",
    x1: 5637.91,
    y1: 362.906,
    x2: 14120.6,
    y2: 5642.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B84E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F68E48"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1533_224",
    x1: 4248.16,
    y1: 4898.86,
    x2: 4384.1,
    y2: 8157.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9A03C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD3);
export default __webpack_public_path__ + "static/media/D3.a05a3357bc90cca05e89a47bca83d92b.svg";
export { ForwardRef as ReactComponent };